import { render, staticRenderFns } from "./nlp.vue?vue&type=template&id=7afe33a8&scoped=true&"
import script from "./nlp.vue?vue&type=script&lang=js&"
export * from "./nlp.vue?vue&type=script&lang=js&"
import style0 from "./nlp.vue?vue&type=style&index=0&id=7afe33a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afe33a8",
  null
  
)

export default component.exports